import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

export type CoreUIStatCardIndicator = 'success' | 'warning' | 'danger';

@Component({
  selector: 'core-ui-stat-card',
  standalone: false,
  templateUrl: './core-ui-stat-card.component.html',
  styleUrls: ['./core-ui-stat-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CoreUIStatCardComponent {
  @Input() label = '';
  @Input() value: number | string = 0;
  @Input() description = '';
  @Input() indicator: CoreUIStatCardIndicator | null = null;
  @Input() selected = false;
  @Input() disabled = false;

  @Output() clicked = new EventEmitter<void>();
}
